import {BuyHistoryDto} from '../../common/shared/api/nicolas/vo/BuyHistoryDto.interface';
import {BuyHistory} from '../generated/types';
import {createSaleType} from './SaleType';
import {createTicketKind} from './TicketKind';
import {createTicketType} from './TicketType';

export function createBuyHistory({
  title,
  ticket_uid,
  ticket_type,
  sale_type,
  created_dt,
  is_refundable,
}: BuyHistoryDto): BuyHistory {
  return {
    title,
    ticketUid: BigInt(ticket_uid).toString(),
    ticketType: createTicketType(ticket_type),
    ticketKind: createTicketKind(ticket_type),
    saleType: createSaleType(sale_type),
    createdDt: created_dt,
    isRefundable: is_refundable,
  };
}
